export class WebhookModel {

  id?: number;
  url?: string;
  clienteToken?: string;
  payload?: string;
  tokenLocal?: string;
  dataVencimento?: any;
  usuarioId?: number;
  usuarioNome?: string;

}
